import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "rdch__interactive--select-table" };
const _hoisted_2 = { class: "rd-select" };
const _hoisted_3 = { class: "wrap rd-select__wrapper" };
const _hoisted_4 = ["placeholder"];
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("i", { class: "arrow-down" }, null, -1);
const _hoisted_6 = {
    key: 0,
    class: "no-click rd-select__columns"
};
const _hoisted_7 = { class: "no-click rd-select__columns__list" };
const _hoisted_8 = {
    key: 0,
    class: "customScrollBar no-click rd-select__columns__groups"
};
const _hoisted_9 = { class: "rd-select__columns__title" };
const _hoisted_10 = {
    key: 0,
    class: "rd-select__columns__row"
};
const _hoisted_11 = ["onClick", "innerHTML"];
const _hoisted_12 = {
    key: 1,
    class: "no-click rd-select__columns__empty-select"
};
const _hoisted_13 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _directive_focus = _resolveDirective("focus");
    const _directive_click_outside = _resolveDirective("click-outside");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("label", null, _toDisplayString(_ctx.$t('_table')), 1),
            _createElementVNode("div", _hoisted_3, [
                _withDirectives(_createElementVNode("input", {
                    ref: "input-destination",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.selectedOption) = $event)),
                    type: "text",
                    placeholder: _ctx.$t('integrations.select'),
                    onClick: _cache[1] || (_cache[1] =
                        //@ts-ignore
                        (...args) => (_ctx.openDestinationSelect && _ctx.openDestinationSelect(...args)))
                }, null, 8, _hoisted_4), [
                    [_vModelText, _ctx.selectedOption],
                    [_directive_focus, _ctx.openDestinationSelect]
                ]),
                _hoisted_5,
                (_ctx.isDestinationColumnsActive)
                    ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                            (_ctx.selectOptions.length)
                                ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectOptions, (connectors, index) => {
                                        return (_openBlock(), _createElementBlock("li", {
                                            key: index,
                                            class: "no-click"
                                        }, [
                                            _createElementVNode("strong", _hoisted_9, _toDisplayString(connectors[0]), 1),
                                            (connectors[1].length)
                                                ? (_openBlock(), _createElementBlock("ul", _hoisted_10, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(connectors[1], (connector) => {
                                                        return (_openBlock(), _createElementBlock("li", {
                                                            key: connector.key,
                                                            class: "rd-select__columns__item",
                                                            onClick: ($event) => (_ctx.selectConnector(connector, $event)),
                                                            innerHTML: connector.name
                                                        }, null, 8, _hoisted_11));
                                                    }), 128))
                                                ]))
                                                : _createCommentVNode("", true)
                                        ]));
                                    }), 128))
                                ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                    _createElementVNode("span", {
                                        innerHTML: _ctx.$t('integrations.empty-destiny')
                                    }, null, 8, _hoisted_13)
                                ]))
                        ])
                    ])), [
                        [_directive_click_outside, _ctx.closeDestinationSelect]
                    ])
                    : _createCommentVNode("", true)
            ])
        ])
    ]));
}
